import React, { useEffect } from "react";
import { useRecoilState } from "recoil";
import {
  optionGroupType,
  optionType,
} from "../../../controller/StoreController";
import { useToast } from "../../../controller/ToastController";
import { langState, langText } from "../../../recoil/lang";
import { getOptionName, getOptionTypeName } from "../../../utils/util";

interface OptionProps {
  option: optionGroupType[];
  selectedOption: number[][];
  setSelectedOption: (selectedOption: number[][]) => void;
}

const OptionList = ({
  option,
  selectedOption,
  setSelectedOption,
}: OptionProps) => {
  const showToast = useToast();
  const [lang, setLang] = useRecoilState<number>(langState);

  console.log("selectedOption", selectedOption);

  // 필수 1개
  const handleRadioChange = (
    item: optionType,
    index: number,
    optionIndex: number
  ) => {
    let temp = [...selectedOption];
    temp[index] = [optionIndex];
    setSelectedOption(temp);
  };
  // 필수 여러개 or 최대선택
  const handleCheckboxChange = (
    item: optionType,
    index: number,
    optionIndex: number
  ) => {
    let temp = [...selectedOption];

    const indexToRemove = temp[index].indexOf(optionIndex);
    if (indexToRemove !== -1) {
      temp[index].splice(indexToRemove, 1);
    } else {
      if (option[index].option_input_max <= temp[index].length) {
        if (option[index].option_input_min === 0) {
          showToast(
            langText.optionModal_title_Maximum[lang] +
              option[index].option_input_max +
              langText.optionModal_detail_choice[lang],
            "error"
          );
        } else {
          showToast(
            langText.optionModal_title_Required[lang] +
              option[index].option_input_max +
              langText.optionModal_detail_choice[lang],
            "error"
          );
        }
        return;
      } else {
        temp[index].push(optionIndex);
      }
    }
    setSelectedOption(temp);
  };

  // 옵션 초기화
  const optionReset = () => {
    setSelectedOption(
      option?.map((prdOption) =>
        (prdOption.option_input_max === 0 &&
          prdOption.option_input_min === 0) ||
        prdOption.option_input_min === 1
          ? [0]
          : []
      )
    );
  };

  useEffect(() => {
    optionReset();
  }, [option]);

  return (
    <div className="optionListWrap">
      {option.map((optionGroup: optionGroupType, index: number) => {
        return (
          optionGroup.option_list.length > 0 && (
            <div className="oprionList">
              <div className="optionName">
                <h3>{getOptionTypeName(optionGroup, lang)}</h3>

                {/* 필수1개 - radio */}
                {((optionGroup.option_input_min === 0 &&
                  optionGroup.option_input_max === 0) ||
                  (optionGroup.option_input_min === 1 &&
                    optionGroup.option_input_max === 1)) && (
                  <span className="require">
                    ({langText.optionModal_title_Required[lang]}1
                    {langText.title_detail_count[lang]})
                  </span>
                )}
                {/* 필수1개 이상 - checkbox */}
                {optionGroup.option_input_min !== 0 &&
                  optionGroup.option_input_max > 1 && (
                    <>
                      <span className="require">
                        ({langText.optionModal_title_Required[lang]}
                        {optionGroup.option_input_min}
                        {langText.title_detail_count[lang]})
                      </span>
                      {optionGroup.option_input_min !==
                        optionGroup.option_input_max && (
                        <span className="noneRequire">
                          ({langText.optionModal_title_Maximum[lang]}
                          {optionGroup.option_input_max}
                          {langText.title_detail_count[lang]})
                        </span>
                      )}
                    </>
                  )}
                {/* 최대 선택 이상 - checkbox */}
                {optionGroup.option_input_min === 0 &&
                  optionGroup.option_input_max > 0 && (
                    <span className="noneRequire">
                      ({langText.optionModal_title_Maximum[lang]}{" "}
                      {optionGroup.option_input_max}
                      {langText.title_detail_count[lang]})
                    </span>
                  )}
              </div>
              <div className="optionButtonWrap">
                {optionGroup.option_list.map(
                  (option: optionType, optionIndex: number) => {
                    const optionId = `option_${index}_${optionIndex}`;
                    const requireType =
                      (optionGroup.option_input_min === 0 &&
                        optionGroup.option_input_max === 0) ||
                      (optionGroup.option_input_min === 1 &&
                        optionGroup.option_input_max === 1);
                    const inputName = `${requireType ? "require" : ""}${index}`;
                    const isSelected =
                      selectedOption.length > 0 &&
                      selectedOption[index].includes(optionIndex);

                    return requireType ? (
                      // 필수 1개
                      <div
                        key={optionIndex}
                        className={`optionButton ${isSelected ? "active" : ""}`}
                      >
                        <label htmlFor={optionId}>
                          <input
                            type="radio"
                            id={optionId}
                            name={inputName}
                            value={option.option_id}
                            checked={isSelected}
                            onChange={() => {
                              handleRadioChange(option, index, optionIndex);
                            }}
                          />
                          <h3>{getOptionName(option, lang)}</h3>
                          <h3 className="optionPrice">
                            {option.option_price_nrm}원
                          </h3>
                        </label>
                      </div>
                    ) : (
                      // 필수 여러개 또는 최대선택
                      <div
                        key={optionIndex}
                        className={`optionButton ${isSelected ? "active" : ""}`}
                      >
                        <label htmlFor={optionId}>
                          <input
                            type="checkbox"
                            id={optionId}
                            name={inputName}
                            value={option.option_id}
                            checked={isSelected}
                            onChange={() => {
                              handleCheckboxChange(option, index, optionIndex);
                            }}
                          />
                          <h3>{getOptionName(option, lang)}</h3>
                          <h3 className="optionPrice">
                            {option.option_price_nrm}원
                          </h3>
                        </label>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          )
        );
      })}
    </div>
  );
};
export default OptionList;
